@if (needToShowPaginationColumn || hasFilters) {
  <div class="row mbs-table_nav">
    @if (hasFilters) {
      <div
        [class.col-6]="!fullContentWidth && !wideContentMode"
        [class.col-8]="!fullContentWidth && wideContentMode"
        [class.col-12]="fullContentWidth">
        @if (filtersGroup) {
          <ng-container [ngTemplateOutlet]="filtersGroup?.template" />
        }

        @if (myFilters?.length > 0) {
          <div class="row mbs-table_filter">
            @for (filter of myFilters; track filter) {
              <div
                class="col-auto mbs-table_filter-item"
                [class.mbs-table_filter-divider]="filter.mode === 'divider'"
                [class.mbs-table_filter-label]="filter.mode === 'label'">
                <ng-container [ngTemplateOutlet]="filter.template" />
              </div>
            }
          </div>
        }

        @if (myContent && (!myFilters || myFilters?.length === 0 || !filtersGroup)) {
          <div class="mbs-table-nav_custom-content">
            <ng-container
              [ngTemplateOutlet]="myContent.template"
              [ngTemplateOutletContext]="{ $implicit: myContent.context }" />
          </div>
        }
      </div>
    }

    @if (needToShowPaginationColumn) {
      <div
        [class.col-4]="!fullContentWidth && wideContentMode && hasFilters"
        [class.col-6]="!fullContentWidth && !wideContentMode"
        [class.col-12]="fullContentWidth || (!wideContentMode && !hasFilters)">
        <div class="form-row align-items-center justify-content-end">
          @if (customPrependControls.length > 0) {
            <div class="col-auto">
              @for (control of customPrependControls; track control) {
                <ng-container [ngTemplateOutlet]="control.template" />
              }
            </div>
          }

          @if (showPagination) {
            <div class="col-auto">
              <ngb-pagination
                class="mbs-table_pagination"
                [collectionSize]="paginationOptionsInternal.dataSize"
                [maxSize]="paginationOptionsInternal.maxSize"
                [page]="paginationOptionsInternal.page"
                [pageSize]="paginationOptionsInternal.pageSize"
                [rotate]="paginationOptionsInternal.rotate"
                (pageChange)="onPageChange($event)">
                <ng-template ngbPaginationPrevious>
                  <span
                    class="fa fa-long-arrow-left arrow"
                    [container]="'auto'"
                    [ngbTooltip]="'Previous page'"
                    [placement]="'top-right'"
                    [tooltipClass]="'text-nowrap -no-arrow'"></span>
                </ng-template>

                <ng-template ngbPaginationNext>
                  <span
                    class="fa fa-long-arrow-right arrow"
                    [container]="'auto'"
                    [ngbTooltip]="'Next page'"
                    [placement]="'top-right'"
                    [tooltipClass]="'text-nowrap -no-arrow'"></span>
                </ng-template>
              </ngb-pagination>
            </div>
          }

          @if (showExportToCSVButton) {
            <div class="col-auto lh-1">
              <mbs-button
                class="mbs-pagination-btn_export_to_csv"
                [container]="'auto'"
                [ngbTooltip]="'Export to CSV'"
                [placement]="'top-right'"
                [tooltipClass]="'text-nowrap -no-arrow'"
                (click)="export.emit()">
                {{ exportButtonName }}
              </mbs-button>
            </div>
          }

          @if (
            paginationOptionsInternal.pageSizeList &&
            paginationOptionsInternal.dataSize > 0 &&
            paginationOptionsInternal.pageSizeList[0] < paginationOptionsInternal.dataSize
          ) {
            <div class="col-auto d-flex align-self-stretch align-items-center">
              <mbs-dropdown-button
                class="mbs-pagination-btn_perpage"
                [dropdownContainer]="null"
                [dropdownPlacement]="'bottom-right'"
                [dropdownTemplate]="pageSizeDropdownTemplate">
                {{ getPageSizeText(paginationOptionsInternal.pageSize) }}
              </mbs-dropdown-button>
              <ng-template #pageSizeDropdownTemplate>
                @for (size of paginationOptionsInternal.pageSizeList; track size) {
                  <button
                    ngbDropdownItem
                    class="-sm"
                    (click)="handleChangePageSize(size)">
                    {{ getPageSizeMenuText(size) }}
                  </button>
                }
              </ng-template>
            </div>
          }

          @if (showRefreshButton) {
            <div class="col-auto lh-1">
              <mbs-button
                class="mbs-pagination-btn_refresh"
                [attr.data-e2e]="elementSelectors.id.refreshButton"
                [container]="'auto'"
                [icon]="'ico ico-Refresh'"
                [loading]="refreshing"
                [ngbTooltip]="'Refresh'"
                [placement]="'top-right'"
                [tooltipClass]="'-no-arrow'"
                (click)="refresh.emit()" />
            </div>
          }

          @if (enableSwitcher && switcherView) {
            <div class="col-auto">
              <div class="mbs-table_switcher">
                <div class="mbs-table_switcher-item">
                  <button
                    class="ctrl ctrl-sm mbs-table_switcher-ctrl"
                    [class.active]="myViewMode === sharedPersistentStateEnum.table"
                    [container]="'auto'"
                    [ngbTooltip]="'Table view'"
                    [placement]="'top-right'"
                    [tooltipClass]="'text-nowrap -no-arrow'"
                    (click)="onViewChange(sharedPersistentStateEnum.table)">
                    <span class="ico ico-ListView"></span>
                  </button>
                </div>

                <div class="mbs-table_switcher-item">
                  <button
                    class="ctrl ctrl-sm mbs-table_switcher-ctrl"
                    [class.active]="myViewMode === sharedPersistentStateEnum.grid"
                    [container]="'auto'"
                    [ngbTooltip]="'Tile view'"
                    [placement]="'top-right'"
                    [tooltipClass]="'text-nowrap -no-arrow'"
                    (click)="onViewChange(sharedPersistentStateEnum.grid)">
                    <span class="ico ico-GridView"></span>
                  </button>
                </div>
              </div>
            </div>
          }

          @if (customAppendControls.length > 0) {
            <div class="col-auto">
              @for (control of customAppendControls; track control) {
                <ng-container [ngTemplateOutlet]="control.template" />
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}
